/**
 * Entrada do frontend React do Report Manager (spec 0008).
 *
 * O `styles.css` do design system entra UMA vez, aqui: ele traz as fontes, os tokens e um reset
 * global que mexe em `body`, titulos e controles nativos.
 */

import '@ledger-glass/react/styles.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Plano de controle: o catalogo muda por acao de quem esta na tela, e cada mutacao invalida o
      // que precisa. Refetch por foco traria consulta ao Auth so por trocar de aba.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const root = document.getElementById('root')
if (root === null) throw new Error('Elemento #root nao encontrado no index.html.')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
